import { Gender, PersonalDetailsSource, AddressType } from '../enums/enum';

export class PersonalDetailsRequest {
    public CustomerId = '';
    public FullName = '';
    public FirstName = '';
    public MiddleName = '';
    public LastName = '';
    public Gender: Gender = null;
    public DateOfBirth = '';
    public Pan = '';
    public Aadhaar = '';
    public Source: PersonalDetailsSource = null;
    public PhoneNumber = '';
    public PhoneNumberVerified: boolean = null;
    public City = '';
    public PinCode = '';
    public Area = '';
    public Location = '';
    public AddressType: AddressType = null;
    constructor() {
        this.CustomerId = '';
        this.FullName = '';
        this.FirstName = null;
        this.MiddleName = null;
        this.LastName = null;
        this.Gender = null;
        this.DateOfBirth = '';
        this.Pan = '';
        this.Aadhaar = '';
        this.Source = null;
        this.PhoneNumber = '';
        this.PhoneNumberVerified = null;
        this.City = '';
        this.PinCode = '';
        this.Area = '';
        this.Location = '';
        this.AddressType = null;
    }
}

export class SocialDetails {
    public ExternalId = '';
    public DateOfBirth = '';
    public Gender: Gender;
    public FullName = '';
    public Pan = '';
    public Aadhaar = '';
    public Source: PersonalDetailsSource = null;
    constructor() {
        this.ExternalId = '';
        this.DateOfBirth = '';
        this.Gender = null;
        this.FullName = '';
        this.Pan = '';
        this.Aadhaar = '';
        this.Source = PersonalDetailsSource.Customer;
    }
}

export class MerchantCustomerDetails {
    public FullName = '';
    public AddressLine1 = '';
    public AddressLine2 = '';
    public Location = '';
    public Area = '';
    public City = '';
    public PinCode = '';
    public EmailAddress = '';
    public MobileNumber = '';
    public Gender = '';
    public AadhaarNumber = '';
    public DateOfBirth = '';
    constructor() {
        this.FullName = '';
        this.AddressLine1 = '';
        this.AddressLine2 = '';
        this.Location = '';
        this.Area = '';
        this.City = '';
        this.PinCode = '';
        this.EmailAddress = '';
        this.MobileNumber = '';
        this.Gender = '';
        this.AadhaarNumber = '';
        this.DateOfBirth = '';
    }
}

export class MerchantCustomerResponse {
    public AddressLine1 = '';
    public AddressLine2 = '';
    public City = '';
    public EmailAddress = '';
    public FullName = '';
    public MobileNumber = '';
    public PinCode = '';
    public RedirectUrl = '';
    public PanNumber = '';
    public Gender = '';
    public AadhaarNumber = '';
    public DateOfBirth = '';
    constructor() {
        this.AddressLine1 = '';
        this.AddressLine2 = '';
        this.City = '';
        this.EmailAddress = '';
        this.FullName = '';
        this.MobileNumber = '';
        this.PinCode = '';
        this.RedirectUrl = '';
        this.PanNumber = '';
        this.Gender = '';
        this.AadhaarNumber = '';
        this.DateOfBirth = '';
    }
}

export class Address {
    public City = '';
    public Location = ''; // AddressLine1
    public Area = ''; // AddressLine2
    public PinCode = '';
    public State = '';
    public Type: AddressType = null;
    public Source: PersonalDetailsSource = null;
    constructor() {
        this.City = '';
        this.Location = '';
        this.Area = '';
        this.PinCode = '';
        this.State = '';
        this.Type = AddressType.Correspondence;
        this.Source = null;
    }
}

export class IPVAddress {
    public City = '';
    public Location = ''; // AddressLine1
    public Area = ''; // AddressLine2
    public PinCode = '';
    public State = '';
    constructor() {
        this.City = '';
        this.Location = '';
        this.Area = '';
        this.PinCode = '';
        this.State = '';
    }
}

export class PoaAddress {
    public City = '';
    public AddressLine1 = '';
    public AddressLine2 = '';
    public PinCode = '';
    public LiveWith = '';
    public AddressType: AddressType = null;
    public TrustedMerchantId = '';
    public CustomerId = '';
    constructor() {
        this.City = '';
        this.AddressLine1 = '';
        this.AddressLine2 = '';
        this.PinCode = '';
        this.LiveWith = null;
        this.AddressType = null;
        this.TrustedMerchantId = '';
        this.CustomerId = '';
    }
}

export class AddressResponse {
    public City: string;
    public AddressLine1: string;
    public AddressLine2: string;
    public PinCode: number;
    public Type: string;
    public Source: string;
}

export class ContactDetails {
    public EmailAddress = '';
    public PhoneNumber = '';
    public VerifiedMobile = false;
    constructor() {
        this.EmailAddress = '';
        this.PhoneNumber = '';
        this.VerifiedMobile = false;
    }
}

export class PersonalDetailsResponse {
    public CustomerId = '';
    public SocialDetails: SocialDetails = null;
    public Addresses: Address[] = null;
    public Contact: ContactDetails = null;
    public MerchantCustomerDetails: MerchantCustomerDetails = null;
    public MerchantCustomerResponse: MerchantCustomerResponse = null;
    constructor() {
        this.CustomerId = '';
        this.SocialDetails = new SocialDetails();
        const address = new Address();
        this.Addresses = new Array<Address>();
        this.Addresses.push(address);
        this.Contact = new ContactDetails();
        this.MerchantCustomerDetails = new MerchantCustomerDetails();
        this.MerchantCustomerResponse = new MerchantCustomerResponse();
    }
}

export class SaveAddress {
    public AddressLine1 = ''; // Location
    public AddressLine2 = ''; // Area
    public City = '';
    public PinCode = '';
    public Type: AddressType = null;
    constructor(location: string, area: string, city: string, pincode: string, type: AddressType) {
        this.AddressLine1 = location;
        this.AddressLine2 = area;
        this.City = city;
        this.PinCode = pincode;
        this.Type = type;
    }
}

export class ChatCustomerDetails {
    public name = '';
    public email = '';
    constructor(name: string, email: string) {
        this.name = name;
        this.email = email;
    }
}

export class CityPincodeMapping {
    public pincode: string;
    public city: string[];
    public locality: string[];
}

export class State {
    public id: string;
    public name: string;
    public cibilCode: string;
}

export class NumberOfAttempts {
    public aadhaar: number;
    public pan: number;
    constructor(attempt: number) {
        this.aadhaar = attempt;
        this.pan = attempt;
    }
}

export class UserAccountStatus {
    public BlockType: number;
    public BlockedTill: string;
    public IsActive: boolean;
}


export class PersonalDetailsSession {
    public CustomerId = '';
    public FullName = '';
    public Gender: Gender = null;
    public DateOfBirth = '';
    public Pan = '';
    public Aadhaar = '';
    public PinCode = '';
    public City = '';
    public Area = '';
    public Location = '';

    constructor(CustomerId: string) {
        this.CustomerId = CustomerId;
        this.FullName = '';
        this.Gender = null;
        this.DateOfBirth = '';
        this.Pan = '';
        this.Aadhaar = '';
        this.City = '';
        this.PinCode = '';
        this.Area = '';
        this.Location = '';
    }
}
